import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ApiService } from "../../services/apiService";
import Table from "./Table";
import { formatTimestamp } from "../../utils";
import { transformServiceType } from "../../utils/transformServiceType";

const CustomerAutosTable = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const isAuthenticated = useSelector((state) => state.login.user !== null);
  const [customerAutoOrders, setCustomerAutoOrders] = useState([]);
  const [matchedSubscription, setMatchedSubscription] = useState(null);

  const fetchCustomerAutoOrders = async () => {
    setMatchedSubscription(null);
    setCustomerAutoOrders([]);
    try {
      const response = await ApiService.getIndividualUserAutoOrder();
      const orders = response?.data?.data || [];

      const matched = orders.find(
        (order) => order.service_name === currentPath
      );
      if (matched) {
        setMatchedSubscription(matched);
        setCustomerAutoOrders(matched.subscriptions || []);
      }
    } catch (error) {
      console.error("Error fetching customer auto:", error);
    }
  };

  useEffect(() => {
    if (isAuthenticated && currentPath.includes("auto")) {
      fetchCustomerAutoOrders();
    } else {
      setMatchedSubscription(null);
      setCustomerAutoOrders([]);
    }
  }, [currentPath, isAuthenticated]);

  if (!matchedSubscription) return null;

  const autodetails = [
    {
      name: "Username",
      selector: (row) => row.social_username,
    },
    { name: "Quantity", selector: (row) => row.quantity },
    { name: "Number of Post", selector: (row) => row.no_of_posts },
    {
      name: "Last Post",
      selector: (row) => (
        <a href={row.last_post} target="_blank" rel="noreferrer">
          {row.last_post}
        </a>
      ),
    },
    { name: "Post Done", selector: (row) => row.post_done },
    {
      name: "Service Name",
      selector: (row) => transformServiceType(row.service_name),
    },
    { name: "Order Date", selector: (row) => formatTimestamp(row.createdAt) },
  ];

  return (
    <div className="my-1 px-20 lg:px-4 md:px-3 sm:px-2 xs:px-1">
      <Table
        title="Your Auto Order for this service"
        column={autodetails}
        data={customerAutoOrders}
        paginationPerPage={5}
      />
    </div>
  );
};

export default CustomerAutosTable;
